var map = {
	"./EGGS0001.jpg": "10f8",
	"./EGGS0002.jpg": "a021",
	"./EGGS0003.jpg": "9278",
	"./EGGS0004.jpg": "169c",
	"./EGGS0005.jpg": "a5bc",
	"./EGGS0006.jpg": "724e",
	"./EGGS0007.jpg": "5976",
	"./EGGS0008.jpg": "c40c",
	"./EGGS0009.jpg": "3510"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f6d1";